import React from 'react'

import { useTranslation } from 'react-i18next'

import MustBePremiumDialog from '@components/shared/dialogs/MustBePremiumDialog'
import Divider from '@layout/Divider'
import SideNavItem from '@layout/SideNavMenu/SideNavItem'
import { useDialogStore } from '@stores/dialog.store'
import { useSession } from '@stores/globalData/globalData.store'
import PageRoutes from '@utils/page-routes'

const GroupsNav: React.FC = () => {
  const { t } = useTranslation()
  const session = useSession()
  const openDialog = useDialogStore((s) => s.openDialog)

  if (!session.current_user) return null

  const createNewGroup = (): void => {
    if (session.current_user?.has_premium_features) window.location.href = PageRoutes.newGroupPath()
    else openDialog('must_be_premium_group')
  }

  return (
    <>
      {/* Groups */}
      <Divider />
      {session.community.default_community ? (
        <p className="font-medium text-base ml-2 mb-2">{t('siteSidebar.myGroups')}</p>
      ) : (
        <p className="font-medium text-base ml-2 mb-2">{t('siteSidebar.myClassesAndGroups')}</p>
      )}
      {session.user_groups.groups.map((group) => (
        <SideNavItem
          key={group.id}
          label={group.name}
          href={PageRoutes.groupPath(group.id)}
          external
          iconName="nf-community-sm"
          iconSize="text-h3"
        />
      ))}
      {session.user_groups.remaining > 0 && (
        <SideNavItem
          label={t('siteSidebar.moreGroups')}
          href="/groups#/yours"
          external
          iconName="nf-community-sm"
          iconSize="text-h3"
        />
      )}

      {/* New Group */}
      {session.community.permissions?.can_create_group && (
        <SideNavItem
          label={t('siteSidebar.newGroup')}
          iconName="nf-create"
          onClick={createNewGroup}
        />
      )}
      <MustBePremiumDialog
        name="must_be_premium_group"
        title={t('content.newGroup')}
        action={t('action.newGroup')}
        permission="new_group"
      />
    </>
  )
}

export default GroupsNav
